import Medication from "./Medication";

const MedicationsList = ({ medications, setMedications, addMedication }) => {
  const medicationTypes = [
    "Tablet",
    "Capsule",
    "Syrup",
    "DT",
    "Injection",
    "Cream",
  ];
  const medicationFrequencies = [
    "1-0-1",
    "1-0-0",
    "0-1-1",
    "0-1-0",
    "1-1-0",
    "1-1-1",
    "0-0-1",
    "SOS",
    "Once a day",
    "Twice a day",
    "Thrice a day",
    "4 times a day",
    "5 times a day",
    "After every 3 hours",
    "After every 4 hours",
    "After every 6 hours",
  ];
  const medicationInstructions = ["Before Meal", "After Meal"];

  const handleFieldChange = (index, event) => {
    const { name, value } = event.target;
    setMedications((meds) =>
      meds.map((medication, i) => {
        if (i === index) {
          return { ...medication, [name]: value };
        }
        return medication;
      })
    );
  };

  // const addMedication = () => {
  //     setMedications([...medications, { medicine: '', dosage: '', frequency: '', duration: '', route: '', notes: '' }]);
  //   };

  const removeMedication = (index) => {
    setMedications((meds) => meds.filter((_, i) => i !== index));
  };

  return (
    <div>
      <h2 className="text-lg font-semibold text-gray-800 mb-1">Medication</h2>
      <hr className="mt-1 mb-4" />
      {medications.map((medication, index) => (
        <Medication
          key={index}
          medication={medication}
          onFieldChange={handleFieldChange}
          removeMedication={removeMedication}
          index={index}
          medicationTypes={medicationTypes}
          medicationFrequencies={medicationFrequencies}
          medicationInstructions={medicationInstructions}
        />
      ))}
      <button
        type="button"
        onClick={addMedication}
        className="text-blue-700 bg-blue-100 hover:bg-blue-200 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:focus:ring-blue-900 transition-colors"
      >
        Add Another Medication
      </button>
    </div>
  );
};

export default MedicationsList;
